import lodash from 'lodash';

import type { DocumentStyle } from './../../ricos-schema/legacy/wix/rich_content/v1/index.js';
import type { RicosTheme } from './../../ricos-types/index.js';

import { TextStyleTransformer } from '../text-style-transformer.js';
import createCustomStyles from './generators/customStyles.js';
import createPalette from './generators/palette.js';
import createTypography from './generators/typography.js';
import { buildCssVarsObj } from './themeUtils.js';

export const buildThemeCssVars = (theme: RicosTheme, documentStyle: DocumentStyle) => {
  const documentStyleTheme = TextStyleTransformer.fromDocumentStyle(documentStyle).toTheme();
  const mergedTheme = lodash.merge({}, theme, documentStyleTheme);
  const { palette, paletteConfig, typography, customStyles, nativeStyle } = mergedTheme;

  const { paletteVarsObject } = createPalette(palette, paletteConfig);
  const typographyVarsObject = createTypography(typography);
  const customsVarsObject = createCustomStyles({
    customStyles,
    nativeStyle,
  });

  const breakoutVars = {
    'breakout-normal-padding-start': theme?.breakout?.normalPadding.start ?? '0',
    'breakout-normal-padding-end': theme?.breakout?.normalPadding.end ?? '0',
    'breakout-full-width-padding-start': theme?.breakout?.fullWidthPadding?.start ?? '0',
    'breakout-full-width-padding-end': theme?.breakout?.fullWidthPadding?.end ?? '0',
  };

  const varsObj = {
    ...paletteVarsObject,
    ...typographyVarsObject,
    ...customsVarsObject,
    ...breakoutVars,
  };

  return buildCssVarsObj(varsObj);
};

export const buildThemePortalCssVars = (theme: RicosTheme) => {
  const { palette, paletteConfig, settingsStyles, customStyles = {} } = theme;
  const { paletteVarsObject } = createPalette(palette, {
    settingsActionColor: paletteConfig?.settingsActionColor,
  });

  const customsVarsObject = createCustomStyles({
    customStyles: { staticToolbar: customStyles?.staticToolbar },
    settingsStyles,
  });

  return buildCssVarsObj({
    settingsActionColor: paletteVarsObject.settingsActionColor,
    settingsActionColorTuple: paletteVarsObject.settingsActionColorTuple,
    ...customsVarsObject,
  });
};
